function state() {
  return {
    selectedInsurer: { code: "ALL" },

    fetchParameter: {},
    paymentToInsurerTransaction: {},
    paymentToInsurerTransactionList: [],
    paymentToInsurerTransactionMeta: {},

    insurerBranchList: [],
  };
}

export default state;
